import {Message, Notification} from 'element-ui'

/**
 * 成功通知函数
 * @param {Object} cfg - 配置对象
 * @param {number} cfg.code - 状态码
 * @param {boolean} cfg.success - 是否成功
 * @param {any} cfg.data - 响应数据
 * @param {string} cfg.msg - 提示消息
 */
export const successFn = (cfg) => {
    Notification({
        title: cfg.title || '成功',
        message: cfg.msg || '操作成功',
        type: 'success',
        duration: cfg.duration || 2000,
        position: cfg.position || 'bottom-right'
    });
};

/**
 * 错误通知函数
 * @param {Object} cfg - 配置对象 详见 windyrequest.js 响应拦截器
 * @param {number} cfg.code - 状态码
 * @param {boolean} cfg.success - 是否成功
 * @param {any} cfg.data - 响应数据
 * @param {string} cfg.msg - 提示消息
 */
export const errorFn = (cfg) => {
    Message({
        message: cfg.msg || '操作失败',
        type: 'error',
        duration: cfg.duration || 2000,
        showClose: true
    });
};

export default {
    successFn,
    errorFn
};